import { useAuth } from "react-oidc-context";
import { getCurrentUserLoginFromOidcProfile } from "../utils/currentUserLogin";

export function useCurrentUserLogin(): string {
  const auth = useAuth();
  return getCurrentUserLoginFromOidcProfile(auth.user?.profile);
}
